import PropTypes from 'prop-types';
import * as S from './styles';

export default function RequestTitle({
  title,
  number,
  versionNumber,
  hasVersions,
  baseFontSize,
}) {
  return (
    <S.TitleBox baseFontSize={baseFontSize}>
      <S.Title baseFontSize={baseFontSize}>
        {title || 'Estimate'}
      </S.Title>
      <S.Number baseFontSize={baseFontSize}>
        {number}
      </S.Number>
      {hasVersions && (
      <S.VersionNumber baseFontSize={baseFontSize}>
        #
        {versionNumber}
      </S.VersionNumber>
      )}
    </S.TitleBox>
  );
}

RequestTitle.propTypes = {
  title: PropTypes.string,
  number: PropTypes.string,
  versionNumber: PropTypes.number,
  hasVersions: PropTypes.bool,
  baseFontSize: PropTypes.number,
};

RequestTitle.defaultProps = {
  title: '',
  number: '',
  versionNumber: 0,
  hasVersions: false,
  baseFontSize: 14,
};
